import React from 'react'

import { theme } from '../../Assets/Styles/theme'
import { CONFIG } from '../../Config/config'

const pipe = '|' // Pipe separator '|'
const color = theme.colors.primary.replace('#', '0x') // Example: "OxFFFFFF"

/**
 * Convert Point object to Google Maps API compatible coordinates string
 * @param {object} point
 * @param {number} point.latitude
 * @param {number} point.longitude
 * @returns {sting} Google Maps API compatible coordinates string
 * @example { latitude: 33.01, longitude: 55.23 } => "33.01,55.23"
 */
const pointToLatLongString = point =>
  `${Number(point.latitude).toFixed(5)},${Number(point.longitude).toFixed(5)}`
// 5 decimal places is enough accuracy

/**
 * Generate path parameter from array of points for Google Static Map
 * @param {Point[]} boundaries Polygon to be rendered on map
 * @returns {string} path string for Google Static Map
 */
const boundariesToPath = boundaries => {
  let polyline = boundaries
    //Add first pont to the end, so polygon will be closed on the map
    .concat([boundaries[0]])
    .map(pointToLatLongString)
    .join(pipe)

  return `&path=fillcolor:${color}${pipe}color:${color}${pipe}${polyline}`
}

/**
 * Component that renders an image with static Google map
 * Docs: https://developers.google.com/maps/documentation/maps-static/intro
 */
export const getStaticGMapURL = ({
  center,
  boundary,
  zoom = 11,
  width = 400,
  height = 400,
}) => {
  var path = boundariesToPath(boundary)

  var url = `https://maps.googleapis.com/maps/api/staticmap
    ?size=${width}x${height}
    ${center ? `&center=${pointToLatLongString(center)}` : ''}
    ${zoom ? `&zoom=${zoom}` : ''}
    ${path}
    &key=${CONFIG.GOOGLE_API_KEY}`.replace(/\s+/g, '')

  return url
}

export default props => {
  var { width = 400, height = 400, className, style = {} } = props

  var url = getStaticGMapURL(props)

  return (
    <img
      className={className}
      style={{ width, height, ...style }}
      src={url}
      alt="map"
    />
  )
}
